import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderPt = () => {
    return (
        <HighlightedText
            text="RESGATE SEU BÔNUS"
            highlights={[{ word: 'SEU' }, { word: 'BÔNUS' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentPt = () => {
    return (
        <HighlightedText
            text="bónus de 325% + 400 giros grátis"
            highlights={[{ word: '325%' }, { word: '+' }, { word: '400' }]}
            breakAfterWords={['325%']}
            className={styles['text_content--FOURTH']}
        />
    )
}
